import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  const [storyExpanded, setStoryExpanded] = useState(false);
  return <section className="bg-gradient-section px-4 py-12 md:px-8 md:py-16" style={{
    paddingTop: "0px"
  }} data-id="element-608" data-mp="38vu7s8uzq744">
      <div className="mx-auto max-w-3xl space-y-14" data-id="element-609" data-mp="2v0i0z33k8q6u">

        {/* Eyebrow */}
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center text-[12px] font-semibold uppercase tracking-[0.28em] text-[#C8A870] md:text-[13px]" data-id="element-610" data-mp="2yxxp8vzq49vz">
          Una historia que podría ser la tuya
        </motion.p>

        {/* Story Block */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="card-premium relative overflow-hidden p-6 md:p-10" style={{
        paddingTop: "20px"
      }} data-id="element-611" data-mp="2g6wqa7ylsecf">
          {/* Línea lateral */}
          <div className="absolute bottom-0 left-0 top-0 w-[2px] bg-gradient-to-b from-transparent via-gold/60 to-transparent" data-id="element-612" data-mp="3nknoawhb2wae" />

          <div className="pl-3 md:pl-6" data-id="element-613" data-mp="5dq4wgakpqev">

            {/* Historia colapsable */}
            <div className={`relative overflow-hidden transition-[max-height] duration-500 ease-out ${storyExpanded ? 'max-h-[1400px]' : 'max-h-[330px]'}`} data-id="element-614" data-mp="h952ou0hnly">
              <div className="space-y-5 md:space-y-6" data-id="element-615" data-mp="33xydkgd5n7e9">

                {/* Inicio */}
                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/80 md:text-[20px]" data-id="element-616" data-mp="3im2ouz9vogn0">
                  María Elena tenía 49 años. Comía bien, caminaba y dormía
                  temprano.
                </p>

                {/* Situación */}
                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/80 md:text-[20px]" data-id="element-617" data-mp="2q3yqreze2g6t">
                  Pero algo había cambiado. Notó cambios en su cuerpo, aunque
                  seguía haciendo muchas cosas como antes. Se despertaba
                  cansada y había días en los que no terminaba de sentirse
                  ella misma.
                </p>

                {/* Intentos previos */}
                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/75 md:text-[19px]" data-id="element-618" data-mp="12uyxl3tqsdmc">
                  Probó ajustar lo que ya hacía: cambió algunas comidas,
                  caminó más y trató de descansar mejor.
                </p>

                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/75 md:text-[19px]" data-id="element-619" data-mp="b4aydxbmpibb">
                  Pero lo que antes le funcionaba ya no respondía de la misma
                  manera.
                </p>

                <p className="font-body text-[17px] italic leading-[1.7] text-foreground/75 md:text-[19px]" data-id="element-620" data-mp="1qkt8hfui3s3y">
                  Y eso empezó a hacerla dudar de todo lo que creía estar
                  haciendo bien.
                </p>

                {/* Insight */}
                <p className="pt-1 font-body text-[17px] font-medium italic leading-[1.6] text-[#F0E8D8] md:text-[19px]" data-id="element-621" data-mp="25n1ccs5i8b6o">
                  Hasta que dejó de buscar otra forma de esforzarse y empezó a
                  preguntarse qué necesitaba realmente.
                </p>

                {/* Nueva interpretación */}
                

                {/* Divider */}
                <div className="divider-fine !mt-7 w-full" data-id="element-622" data-mp="1my4jmspr9qqk" />

                {/* H.E.R. */}
                <p className="font-body text-[16px] font-semibold text-[#C8A870] md:text-[17px]" data-id="element-623" data-mp="1hx71gg4qwwp2">
                  Por eso necesitaba algo diferente: una forma de acompañar
                  esta etapa sin exigirse más.
                </p>

                
              </div>

              {/* Fade */}
              {!storyExpanded && <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#120f0d] via-[#120f0d]/90 to-transparent" data-id="element-624" data-mp="37cdk86tpq98q" />}
            </div>

            {/* Toggle */}
            <div className="mt-5 flex justify-center" data-id="element-625" data-mp="3afaz8kodliih">
              <button type="button" onClick={() => setStoryExpanded(value => !value)} aria-expanded={storyExpanded} className="inline-flex items-center gap-2 font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-[#C8A870] transition-opacity duration-300 hover:opacity-70" data-id="element-626" data-mp="3fee4o689pqqz">
                <span data-id="element-627" data-mp="2rojszrzoq88b">
                  {storyExpanded ? 'Ocultar historia' : 'Leer la historia completa'}
                </span>

                <span className={`transition-transform duration-300 ${storyExpanded ? 'rotate-180' : ''}`} data-id="element-628" data-mp="2wg1t6dtvw4s8">
                  ↓
                </span>
              </button>
            </div>
          </div>
        </motion.div>

      </div>
    </section>;
}